import { StakingPeriodDays, StakingTableStatus } from '../types';

/**
 * Converts period days string to StakingPeriodDays enum
 */
export const toPeriodDaysEnum = (days: string): StakingPeriodDays => {
  const mapping: Record<string, StakingPeriodDays> = {
    '0': StakingPeriodDays.FLEXIBLE,
    '1': StakingPeriodDays.DAYS_1,
    '2': StakingPeriodDays.DAYS_2,
    '3': StakingPeriodDays.DAYS_3,
    '4': StakingPeriodDays.DAYS_4,
    '7': StakingPeriodDays.DAYS_7,
    '30': StakingPeriodDays.DAYS_30,
    '90': StakingPeriodDays.DAYS_90,
    '180': StakingPeriodDays.DAYS_180,
    '360': StakingPeriodDays.DAYS_360,
    '720': StakingPeriodDays.DAYS_720,
  };
  return mapping[days] || StakingPeriodDays.FLEXIBLE;
};

/**
 * Determines phase status based on current phase index
 */
export const determinePhaseStatus = (
  phaseIndex: number,
  currentPhaseIndex: number
): StakingTableStatus => {
  if (phaseIndex < currentPhaseIndex) {
    return StakingTableStatus.FINISHED;
  }
  if (phaseIndex === currentPhaseIndex) {
    return StakingTableStatus.ACTIVE;
  }
  return StakingTableStatus.UPCOMING;
};
